import { useMemo } from "react";
import { Card, Empty } from "antd";
import { useTranslation } from "react-i18next";
import { Column } from "@ant-design/charts";
import { PROGRESSION_CHART_COLORS } from "./chartConstants";
import "./SessionsBarChart.scss";

export function SessionsBarChart({ loading, history }) {
  const { t } = useTranslation("motricity");
  const hist = useMemo(() => history ?? [], [history]);

  const isGrouped =
    hist.length > 0 && hist[0]?.processedScore?.dimensions?.length > 0;

  const data = useMemo(() => {
    if (hist.length === 0) return [];

    if (isGrouped) {
      return hist.flatMap((item) =>
        (item.processedScore?.dimensions || []).map((dim) => ({
          date: item.sessionDate.slice(0, 10),
          value: dim.score,
          serie: dim.name,
        })),
      );
    }

    return hist.map((item) => ({
      date: item.sessionDate.slice(0, 10),
      value: item.processedScore?.total ?? 0,
      serie: t("charts.bar.seriesTotal"),
    }));
  }, [hist, isGrouped, t]);

  const config = useMemo(
    () => ({
      data,
      xField: "date",
      yField: "value",
      colorField: isGrouped ? "serie" : undefined,
      group: isGrouped,
      color: isGrouped ? PROGRESSION_CHART_COLORS : ["#007BFF"],
      autoFit: true,
      height: 280,
      legend: isGrouped ? { position: "bottom" } : false,
      tooltip: { showTitle: true },
    }),
    [data, isGrouped],
  );

  return (
    <Card
      title={t("charts.bar.title")}
      loading={loading}
      variant="outlined"
      className="revi-eval-chart-card revi-sessions-bar"
    >
      {!loading && hist.length < 2 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            hist.length === 0
              ? t("charts.bar.emptyNoData")
              : t("charts.bar.emptyNeedTwo")
          }
        />
      ) : (
        <Column {...config} />
      )}
    </Card>
  );
}
